<template>
  <div>
    <!-- 一级分销商授权 -->
    <!-- 授权弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="一级分销商授权"
      :visible.sync="authorDialogVisible"
      :before-close="authorHandleClose"
      width="53%"
      center
    >
      <el-divider></el-divider>
      <div class="titleBox">
        <div class="titleName">
          <span>当前景区:</span>
          <span>{{scenicName}}</span>
        </div>
        <div>
          <el-input v-model="inputSearch" placeholder="分销商名称" clearable></el-input>
          <el-button @click="searchFn()">查询</el-button>
        </div>
      </div>
      <el-table
        :data="authorTableData"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        style="width: 100%"
      >
        <el-table-column prop="Name" label="分销商名称"></el-table-column>
        <el-table-column prop="LinkMan" label="联系人"></el-table-column>
        <el-table-column prop="Phone" label="电话号"></el-table-column>
        <el-table-column prop="E_Mail" label="Email"></el-table-column>
        <el-table-column prop="SCommission" label="景区佣金"></el-table-column>
        <el-table-column prop="DCommission" label="分销商佣金"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.is_impower==1"
              class="unaudite"
              @click="authorSure(scope.row)"
            >取消授权</el-button>
            <el-button type="text" v-if="scope.row.is_impower==2" @click="autorCancle(scope.row)">授权</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <!-- <el-pagination
          @current-change="handleCurrentChange"
          :current-page="authorPar.page"
          :page-size="8"
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{authorPar.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="total" :current-page="authorPar.page"  @current-change="handleCurrentChange" ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-dialog>
    <!-- 信息授权弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="信息"
      :visible.sync="authorSureDialogVisible"
      :before-close="autorSureHandleClose"
      width="24%"
      center
      class="autorDialog"
      top="35vh"
    >
      <el-divider></el-divider>
      <div class="autorYj">
       
          <div>
          <img :src="imgAuto" alt />
        </div>
        <div>
          <div class="fswc">确定取消授权?</div>
          <div class="autorBtn">
            <el-button class="btnCan" type="text" @click="cancleOneDistributor()">取消</el-button>
            <el-button class="btnSure" type="text" @click="sureOneDistributor()">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 信息授权弹框结束 -->
    <!-- 信息授权取消弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="信息"
      :visible.sync="authorCancleDialogVisible"
      :before-close="autorCancleHandleClose"
      width="24%"
      center
      class="autorDialog"
      top="35vh"
    >
      <el-divider></el-divider>
      <div class="autorYj">
        <div>
          <img :src="imgAuto" alt />
        </div>
        <div>
          <div class="fswc">确定授权为一级分销商?</div>
          <div class="autorBtn">
            <el-button class="btnCan" type="text" @click="cancleAutorCancle()">取消</el-button>
            <el-button class="btnSure" type="text" @click="sureAutorCancle()">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 信息授权取消弹框结束 -->

    <!-- 授权弹框结束 -->
  </div>
</template>

<script>
import {
  getScenicDistributorListPost,
  scenicImpowerDistributorPost,
  scenicCancelImpowerDistributorPost
} from "@/request/scenics.js";
import { Message } from 'element-ui';
export default {
  data() {
    return {
      imgAuto: require("@/images/scenics/sqb.png"),
      authorDialogVisible: false, // 主页授权
      authorSureDialogVisible: false, // 授权按钮
      authorCancleDialogVisible: false, // 取消授权
      authorPar: {
        scenic_id: "",
        name: "",
        page: 1,
        page_size: 8,
        token: ""
      },
      inputSearch: "", // 查询
      scenicName: "",
      total: 1,
      authorTableData: [], // 表格数据
      authorSurePar: {
        scenic_id: "",
        distributor_id: "",
        token: ""
      },
      DistributorId: "",
      ScenicId: ""
    };
  },
  mounted() {
    this.Token = window.sessionStorage.getItem("Token");
  },
  methods: {
    // 点击取消授权
    autorCancle(row) {
      console.log(row);
      this.DistributorId = row.DistributorID;
      this.authorCancleDialogVisible = true;
      // this.authorDialogVisible = false;
    },
    // 点击取消授权关闭弹框X
    autorCancleHandleClose() {
      this.authorCancleDialogVisible = false;
    },
    // 点击取消授权取消
    cancleAutorCancle() {
      this.authorCancleDialogVisible = false;
    },
    // 取消授权确认
    sureAutorCancle() {
      this.authorSurePar = {
        scenic_id: this.ScenicId,
        distributor_id: this.DistributorId,
        token: this.Token
      };
      scenicImpowerDistributorPost(this.authorSurePar).then(res => {
        console.log(res);
        if (res.data.rcode == 200) {
          Message.success(res.data.msg);
          this.authorCancleDialogVisible = false;
          this.getList(this.authorPar);
        } else {
          Message.error(res.data.msg);
        }
      });
    },
    // 取消授权
    cancleOneDistributor() {
      this.authorSureDialogVisible = false;
    },
    // 授权一级分销商确认
    sureOneDistributor() {
      this.authorSurePar = {
        scenic_id: this.ScenicId,
        distributor_id: this.DistributorId,
        token: this.Token
      };
      console.log(this.authorSurePar);
      scenicCancelImpowerDistributorPost(this.authorSurePar).then(res => {
        if (res.data.rcode == 200) {
          Message.success(res.data.msg);
          this.authorSureDialogVisible = false;
          this.getList(this.authorPar);
        } else {
          Message.error(res.data.msg);
        }
      });
    },
    // 点击授权
    authorSure(row) {
      this.DistributorId = row.DistributorID;
      this.authorSureDialogVisible = true;
      // this.authorDialogVisible = false;
    },
    // 点击授权关闭弹框X
    autorSureHandleClose() {
      this.authorSureDialogVisible = false;
    },
    // 搜索
    searchFn() {
      this.authorPar.name = this.inputSearch;
      this.authorPar.page = 1;
      this.getList(this.authorPar);
    },
    // 授权弹框
    autor(row) {
      console.log(row);
      this.authorPar = {
        scenic_id: row.ScenicID,
        name: this.inputSearch,
        page: 1,
        page_size: 8,
        token: this.Token
      };
      this.ScenicId = row.ScenicID;
      this.scenicName = row.Name;
      this.getList(this.authorPar);
      this.authorDialogVisible = true;
    },
    // 获取列表接口
    getList(data) {
      getScenicDistributorListPost(data).then(res => {
        console.log(res);
        this.authorTableData = res.data.result.data;
        this.total = res.data.result.total;
      });
    },
    // 授权关闭弹框X
    authorHandleClose() {
      this.authorDialogVisible = false;
    },
    // 分页
    handleCurrentChange(val) {
      this.authorPar.page = val;
      this.getList(this.authorPar);
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.autorDialog {
  /deep/.el-dialog--center {
    text-align: center;
    height: 266px;
  }
  .autorYj {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 40px;
    .autorBtn {
      margin-top: 42px;
      .btnCan {
        width: 100px;
        height: 40px;
        background: #d9d9d9;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
      .btnSure {
        width: 100px;
        height: 40px;
        background: #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
    }
  }
}

.titleBox {
  display: flex;
  justify-content: space-between;
  .titleName {
    width: 250px;
    height: 40px;
    line-height: 40px;
    margin-bottom: 17px;

    > span:nth-child(1) {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #666666;
    }
    > span:nth-child(2) {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: black;
      margin-left: 15px;
    }
  }
  > div:nth-child(2) {
    .el-input {
      width: 220px;
      margin-right: 20px;
      margin-bottom: 1rem;
    }
    .el-button {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
  }
}

.unaudite {
  color: #ff4d4f;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}

/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
/deep/ .el-dialog{
  min-width: 400px;
}
/deep/ .el-pagination {
  display: flex;
  flex-wrap: wrap;
}
/deep/ .el-table__cell{
  text-align: left !important;
}
/deep/.el-dialog__title{
  color: #000 !important;
  font-family: OPPOSans !important;
  font-size: 20px !important;
  font-weight: 400 !important;
}
</style>